<template>
    <div class="entity-container">
        <div class="nodata" v-if="empty">暂无记录</div>
        <entity-item
            v-else
            v-for="(item, index) in items"
            :key="index"
            :date="item.orderTime"
            :img="item.smallImg"
            :title="item.awardName"
            :desc="item.simpleDesc"
            :exp-no="item.businessNo"
        />
    </div>
</template>

<script>
import EntityItem from '../../componets/records/entityItem';
import recordsMixin from '@/common/js/mixin';

export default {
    name: 'entity',
    components: { EntityItem },
    mixins: [recordsMixin],
    data() {
        return {
            items: [],
            empty: false,
            titleBar: {
                fullScreen: 2,
                visible: 1,
                leftView: [
                    {
                        action: 'back',
                        color: '#000000',
                        icon: 'ppdwebui://resource/drawable/nav_back',
                        callback: this.goBack
                    }
                ],
                titleView: {
                    text: '领取记录',
                    color: '#000000'
                },
                rightView: []
            }
        };
    },
    created() {
        this.customeTitle(this.titleBar);
        this.getRecord();
    },

    mounted() {
        let score = localStorage.getItem('KUserTotalScore') || 0;
        this.POINT('h5_element_imp', {
            page: 'super-等级权益-实物礼品领取记录页',
            tgt_event_id: 'h5_ACT_grade_giftRecord',
            tgt_name: 'h5-ACT-等级权益-实物礼品领取记录页',
            param: score
        });
    },
    methods: {
        isEmpty(val) {
            return val === '' || val === null || val === 'undefined';
        },
        async getRecord() {
            try {
                let { Result, Content } = await this.$http.getReceiveAwardRecord({});
                if (Result === 200) {
                    if (this.isEmpty(Content) || Content.length === 0) {
                        this.empty = true;
                    } else {
                        this.empty = false;
                        this.items = Content;
                    }
                }
            } catch (e) {
                this.empty = true;
                console.log('error--', e);
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.entity-container {
    width: 100%;
    min-height: 100vh;
    background: rgba(245, 248, 250, 1);
    padding-top: 6px;
    .nodata {
        margin-top: 342px;
        font-size: 14px;
        // font-family: fzlt;
        color: #9a9eaa;
        text-align: center;
    }
}
</style>
